document.addEventListener('DOMContentLoaded', () => {
  // Selectors
  const packsConfigurator = document.querySelector('[data-product-packs-configurator]');

  // Subscription selectors (these should work even if packsConfigurator is null)
  const subscriptionOffers = document.querySelectorAll('[data-subscription-offer]');
  const subscriptionCheckbox = document.querySelector('[data-subscription-checkbox]');
  const subscriptionContentWrapper = document.querySelector('.fl-subscription-offer__content-wrapper');
  const subscriptionSelect = document.querySelector('.fl-subscription-offer__select');
  const singlePlanElement = document.querySelector('[data-subscription-plan-id]');

  // Pack selectors (only if packsConfigurator exists)
  const packItems = packsConfigurator ? packsConfigurator.querySelectorAll('[data-pack-item]') : [];
  const variantItems = packsConfigurator ? packsConfigurator.querySelectorAll('[data-variant-item]') : [];
  const maxSavorsElement = packsConfigurator ? packsConfigurator.querySelector('[data-max-savors]') : null;
  const addedSavorsElement = packsConfigurator ? packsConfigurator.querySelector('[data-added-savors]') : null;
  const freeDeliveryText = document.querySelector('[data-pack-free-delivery-text]');
  const errorMessageContainer = document.querySelector('.fl-packs__error-message');
  const errorMessageElement = document.querySelector('[data-pack-error-message]');

  // State
  let selectedPack = null;
  let selectedSavors = {};
  let cartObject = { items: [] };
  let isSubscriptionActive = false;
  let currentSubscriptionDiscount = 0;
  let currentSellingPlanId = null;
  let isUpdatingFromSubscription = false; // Flag to prevent infinite loops

  // Initialize subscription handling
  function initSubscription() {
    if (!subscriptionCheckbox) {
      return;
    }

    // Initial update of subscription options based on any pre-selected pack
    const initialSelectedPack = document.querySelector('[data-pack-item].active');
    updateSubscriptionOptions(initialSelectedPack);

    subscriptionCheckbox.addEventListener('change', () => {
      isSubscriptionActive = subscriptionCheckbox.checked;
      subscriptionContentWrapper?.classList.toggle('visible', isSubscriptionActive);

      if (isSubscriptionActive) {
        const selectedPack = document.querySelector('[data-pack-item].active');

        if (selectedPack) {
          // If we have a selected pack, force select its subscription
          const subscriptionId = selectedPack.dataset.subscriptionId;
          const matchingOption = subscriptionSelect?.querySelector(`option[data-subscription-plan-id="${subscriptionId}"]`);

          if (matchingOption) {
            matchingOption.selected = true;
            currentSellingPlanId = subscriptionId;
            currentSubscriptionDiscount = parseFloat(matchingOption.dataset.subscriptionPlanDiscount) / 100;
          }
        } else {
          // Regular subscription behavior when no pack is selected
          if (subscriptionSelect) {
            const selectedOption = subscriptionSelect.selectedOptions[0];
            currentSellingPlanId = selectedOption.dataset.subscriptionPlanId;
            currentSubscriptionDiscount = parseFloat(selectedOption.dataset.subscriptionPlanDiscount) / 100;

            // Update pack selection based on subscription
            updatePackFromSubscription(currentSellingPlanId);
          } else if (singlePlanElement) {
            currentSellingPlanId = singlePlanElement.dataset.subscriptionPlanId;
            currentSubscriptionDiscount = parseFloat(singlePlanElement.dataset.subscriptionPlanDiscount) / 100;

            // Update pack selection based on subscription
            updatePackFromSubscription(currentSellingPlanId);
          }
        }
      } else {
        currentSellingPlanId = null;
        currentSubscriptionDiscount = 0;
      }

      updateCartObject();
      // Don't call updatePackPrices here - let fl-subscription-checkbox handle price updates
      // to avoid conflicts between the two scripts
    });

    // Update subscription select handler
    if (subscriptionSelect) {
      subscriptionSelect.addEventListener('change', () => {
        const selectedOption = subscriptionSelect.selectedOptions[0];
        currentSellingPlanId = selectedOption.dataset.subscriptionPlanId;
        currentSubscriptionDiscount = parseFloat(selectedOption.dataset.subscriptionPlanDiscount) / 100;

        // Update pack selection based on subscription
        updatePackFromSubscription(currentSellingPlanId);

        updateCartObject();
        // Don't call updatePackPrices here - let fl-subscription-checkbox handle price updates
      });
    }

    // Handle single plan element (when there's only one subscription plan)
    if (singlePlanElement) {
      // Watch for changes in the single plan element (if it's dynamic)
      const observer = new MutationObserver(() => {
        if (!isUpdatingFromSubscription && isSubscriptionActive) {
          const planId = singlePlanElement.dataset.subscriptionPlanId;
          if (planId) {
            updatePackFromSubscription(planId);
          }
        }
      });

      observer.observe(singlePlanElement, {
        attributes: true,
        attributeFilter: ['data-subscription-plan-id']
      });
    }
  }

  // Helper function to get selected flavors from active pack
  function getSelectedFlavorsFromPack() {
    const activePack = document.querySelector('[data-pack-item].active');
    if (!activePack) return [];

    const packType = activePack.dataset.packType || 'v2';

    // V4: multiple selects, each counts as quantity 1
    if (packType === 'v4') {
      const selects = activePack.querySelectorAll('[data-v4-flavor-select]');
      if (!selects.length) return [];

      const counts = {};
      selects.forEach((sel) => {
        const variantId = sel.value;
        if (!variantId) return;
        counts[variantId] = (counts[variantId] || 0) + 1;
      });

      return Object.entries(counts).map(([variantId, quantity]) => ({
        variantId: parseInt(variantId, 10),
        quantity
      }));
    }

    // V2/V3: single select
    let flavorSelect = activePack.querySelector('[data-variant-select]');
    if (!flavorSelect && packsConfigurator) {
      flavorSelect = packsConfigurator.querySelector('[data-global-flavor-select]') || packsConfigurator.querySelector('[data-variant-select]');
    }
    if (!flavorSelect) return [];

    const variantId = flavorSelect.value;
    const packQuantity = parseInt(activePack.dataset.packQuantity) || 1;

    return [{
      variantId: parseInt(variantId, 10),
      quantity: packQuantity
    }];
  }

  // Resolve the product form linked to this configurator (avoids picking a form from cart drawer after first add)
  function getProductForm() {
    const btn = getBuyButton();
    if (btn) {
      return btn.form || (btn.getAttribute('form') ? document.getElementById(btn.getAttribute('form')) : null);
    }
    return document.querySelector('form[is="product-form"]');
  }

  function getBuyButton() {
    const productContext = packsConfigurator ? packsConfigurator.closest('.product') : null;
    return productContext ? productContext.querySelector('buy-buttons button') : document.querySelector('buy-buttons button');
  }

  // Helper function to update cart for V2/V3/V4 simple flavor selector modes
  function updateCartObjectV2() {
    const flavorItems = getSelectedFlavorsFromPack();
    if (!flavorItems || flavorItems.length === 0) return;

    // Get selling plan from the form linked to this product (not from cart drawer)
    let sellingPlanId = null;
    const productForm = getProductForm();
    if (productForm) {
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        sellingPlanId = sellingPlanInput.value;
      }
    }

    const items = flavorItems.map((f) => {
      const item = {
        id: f.variantId,
        quantity: f.quantity
      };
      if (sellingPlanId) {
        item.selling_plan = parseInt(sellingPlanId, 10);
      }
      return item;
    });

    cartObject.items = items;
  }

  const buyButton = getBuyButton();

  if (buyButton) {
    buyButton.addEventListener('click', async (e) => {
      console.log('buyButton clicked');
      e.preventDefault();
      e.stopImmediatePropagation();

      // Set loading state
      buyButton.setAttribute('aria-busy', 'true');

      // Check if we're in V2 mode (no variant composer, using flavor select in packs)
      const hasFlavorSelector = document.querySelector('[data-flavor-selector]') || document.querySelector('[data-v4-flavor-select]');
      const hasVariantComposer = variantItems && variantItems.length > 0;

      if (hasFlavorSelector && !hasVariantComposer) {
        // V2 mode: use flavor selector from active pack
        updateCartObjectV2();
      }

      // Check if we have items to add
      if (!cartObject.items || cartObject.items.length === 0) {
        await showErrorWithDelay('Veuillez choisir au moins une saveur');
        return;
      }

      // In V2 mode, we don't need to check quantities - the pack quantity is automatic
      if (hasVariantComposer) {
        // Original logic for variant composer mode
        const selectedPack = document.querySelector('[data-pack-item].active');
        const packQuantity = parseInt(selectedPack.dataset.packQuantity);
        const totalSelected = cartObject.items.reduce((sum, item) => sum + item.quantity, 0);

        if (totalSelected < packQuantity) {
          const remaining = packQuantity - totalSelected;
          const message = remaining != 0
            ? `Veuillez selectionner ${remaining} saveurs supplémentaires pour compléter votre pack`
            : null;
          await showErrorWithDelay(message);
          return;
        }

        if (totalSelected > packQuantity) {
          const excess = totalSelected - packQuantity;
          const message = excess === 1
            ? 'Please remove 1 savor to match your pack size'
            : `Please remove ${excess} savors to match your pack size`;
          await showErrorWithDelay(message);
          return;
        }

        // Update cart object with current selling_plan from form before adding to cart
        updateCartObject();
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: cartObject.items,
            sections: ['variant-added', 'cart-drawer']
          })
        });

        const result = await response.json();

        if (!response.ok) {
          const message = result.description || result.message || 'Erreur lors de l\'ajout au panier.';
          throw new Error(message);
        }
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: result
          }
        }));

        if (document.querySelector('.cart-drawer')) {
          document.querySelector('.cart-drawer').show()
        } else {
          window.SLIDECART_UPDATE();
          window.SLIDECART_OPEN();
        }
        // document.querySelector('.cart-drawer')?.show();
      } catch (error) {
        console.error('Error adding to cart:', error);
        showError(error.message || 'Erreur lors de l\'ajout au panier. Veuillez réessayer.');
      } finally {
        buyButton.setAttribute('aria-busy', 'false');
      }
    });
  }

  // Initialize with first pack (only if packs exist)
  if (packsConfigurator && packItems.length > 0) {
    // Select the second pack by default (index 1)
    selectedPack = packItems[1] || packItems[0]; // fallback to first pack if second doesn't exist

    // Add active class to the selected pack
    selectedPack.classList.add('active');

    updateMaxSavors(selectedPack);
    updatePackPrices(selectedPack);

    // Handle single variant case (only if variant composer exists)
    if (variantItems && variantItems.length === 1) {
      const singleVariant = variantItems[0];
      const variantId = singleVariant.dataset.variantId;

      // Hide variant selection UI since we only have one variant
      variantItems.forEach(item => {
        item.style.display = 'none';
      });

      // Update the cart object directly with pack quantity
      selectedSavors[variantId] = parseInt(selectedPack.dataset.packQuantity);
      updateCartObject();
      updateSavorCounter();
    }
  }

  // Pack selection handler (only if packs exist)
  if (packsConfigurator) {
    packItems.forEach(pack => {
      pack.addEventListener('click', () => {
        // Remove active class from all packs
        packItems.forEach(p => p.classList.remove('active'));
        // Add active class to clicked pack
        pack.classList.add('active');
        selectedPack = pack;

        if (freeDeliveryText) {
          const hasDelivery = pack.dataset.freeDelivery === 'true';
          if (hasDelivery) {
            freeDeliveryText.classList.remove('fl-hidden');
          } else {
            freeDeliveryText.classList.add('fl-hidden');
          }
        }

        // Update max savors and prices
        updateMaxSavors(pack);
        updatePackPrices(pack);

        // Handle variant selection (only if variant composer exists)
        if (variantItems && variantItems.length > 0) {
          if (variantItems.length === 1) {
            const singleVariant = variantItems[0];
            const variantId = singleVariant.dataset.variantId;
            selectedSavors = {};
            selectedSavors[variantId] = parseInt(pack.dataset.packQuantity);
            updateCartObject();
            updateSavorCounter();
          } else {
            const currentSavorCount = Object.values(selectedSavors).reduce((sum, qty) => sum + qty, 0);
            if (currentSavorCount > parseInt(pack.dataset.packQuantity)) {
              resetSelections();
            }
          }
        }

        // Update subscription options based on selected pack
        // Only update if not triggered by subscription change
        if (!isUpdatingFromSubscription) {
          updateSubscriptionOptions(selectedPack);
        }

        window.igEvents.push({ event: `offer-change-${parseInt(selectedPack?.dataset?.packQuantity || '1')}` });
      });
    });
  }

  // Add button click handler
  variantItems.forEach(variantItem => {
    const addButton = variantItem.querySelector('.fl-variant-item__add-btn');
    const quantityPicker = variantItem.querySelector('.quantity-picker');
    const quantityInput = variantItem.querySelector('.quantity-input');
    const decreaseBtn = variantItem.querySelector('[data-decrease]');
    const increaseBtn = variantItem.querySelector('[data-increase]');

    // Skip if elements don't exist (V2/V3/V4 modes don't have these)
    if (!addButton || !quantityPicker || !quantityInput || !decreaseBtn || !increaseBtn) return;

    addButton.addEventListener('click', () => {
      const variantId = variantItem.dataset.variantId;

      // Check if we can add more savors
      const currentTotal = Object.values(selectedSavors).reduce((sum, qty) => sum + qty, 0);
      const maxQuantity = parseInt(selectedPack.dataset.packQuantity);

      if (currentTotal >= maxQuantity) {
        return;
      }

      // Hide add button, show quantity picker
      addButton.parentElement.classList.add('hidden');
      quantityPicker.classList.remove('hidden');

      // Initialize savor selection
      selectedSavors[variantId] = 1;
      quantityInput.value = 1;
      updateCartObject();
      updateSavorCounter();
    });

    // Quantity picker handlers
    decreaseBtn.addEventListener('click', () => {
      const variantId = variantItem.dataset.variantId;
      const currentQty = parseInt(quantityInput.value);
      if (currentQty > 1) {
        const newQty = currentQty - 1;
        quantityInput.value = newQty;
        selectedSavors[variantId] = newQty;
        updateCartObject();
        updateSavorCounter();
      } else {
        // Remove savor selection
        delete selectedSavors[variantId];
        quantityPicker.classList.add('hidden');
        addButton.parentElement.classList.remove('hidden');
        updateCartObject();
        updateSavorCounter();
      }
    });

    increaseBtn.addEventListener('click', () => {
      const variantId = variantItem.dataset.variantId;
      const currentQty = parseInt(quantityInput.value);
      const currentTotal = Object.values(selectedSavors).reduce((sum, qty) => sum + qty, 0);

      if (currentTotal < parseInt(selectedPack.dataset.packQuantity)) {
        const newQty = currentQty + 1;
        quantityInput.value = newQty;
        selectedSavors[variantId] = newQty;
        updateCartObject();
        updateSavorCounter();
      }
    });

    // Handle manual input
    quantityInput.addEventListener('change', () => {
      const variantId = variantItem.dataset.variantId;
      let newQty = parseInt(quantityInput.value);
      const currentTotal = Object.values(selectedSavors).reduce((sum, qty) => sum + qty, 0) - selectedSavors[variantId];

      // Ensure quantity is within bounds
      if (newQty < 1) newQty = 1;
      if (newQty + currentTotal > parseInt(selectedPack.dataset.packQuantity)) {
        newQty = parseInt(selectedPack.dataset.packQuantity) - currentTotal;
      }

      quantityInput.value = newQty;
      selectedSavors[variantId] = newQty;
      updateCartObject();
      updateSavorCounter();
    });
  });

  // Helper functions
  function updateMaxSavors(pack) {
    if (!maxSavorsElement || !pack) return;
    const packQuantity = pack.dataset.packQuantity;
    maxSavorsElement.textContent = packQuantity;
  }

  function updateSavorCounter() {
    if (!addedSavorsElement) return;
    const currentTotal = Object.values(selectedSavors).reduce((sum, qty) => sum + qty, 0);
    addedSavorsElement.textContent = currentTotal;
  }

  function updateCartObject() {
    // Always read selling_plan from the form linked to this product (not from cart drawer)
    let sellingPlanId = null;
    const productForm = getProductForm();
    if (productForm) {
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        sellingPlanId = sellingPlanInput.value;
      }
    }

    // Fallback to currentSellingPlanId if form doesn't have it
    if (!sellingPlanId && currentSellingPlanId) {
      sellingPlanId = currentSellingPlanId;
    }

    cartObject.items = Object.entries(selectedSavors).map(([variantId, quantity]) => {
      const item = {
        id: parseInt(variantId),
        quantity: quantity
      };

      if (sellingPlanId) {
        item.selling_plan = parseInt(sellingPlanId);
      }

      return item;
    });
    console.log('Cart object updated:', cartObject);
  }

  function updatePackPrices(pack) {
    const priceElement = document.querySelector('[data-pack-price]');
    const priceSubduedElement = document.querySelector('[data-pack-price-subdued]');

    if (priceElement && priceSubduedElement && pack) {
      // Get the price elements from the selected pack
      // Support both V1 (.fl-product-pack__price) and V2/V3/V4 (.fl-pack-v2__final-price) structures
      const packPriceElement = pack.querySelector('.fl-product-pack__price .text-bold')
        || pack.querySelector('.fl-pack-v2__final-price');
      const packSubduedElement = pack.querySelector('.fl-product-pack__price .line-through')
        || pack.querySelector('.fl-pack-v2__compare-price');

      if (packPriceElement) {
        // Copy the exact text content from the pack
        priceElement.textContent = packPriceElement.textContent;

        if (packSubduedElement) {
          priceSubduedElement.textContent = packSubduedElement.textContent;
          priceSubduedElement.classList.remove('hidden');
        } else {
          priceSubduedElement.textContent = '';
          priceSubduedElement.classList.add('hidden');
        }
      }
    }
  }

  function resetSelections() {
    selectedSavors = {};
    cartObject.items = [];

    // Reset UI
    variantItems.forEach(variantItem => {
      const addButton = variantItem.querySelector('.fl-variant-item__add-btn');
      const quantityPicker = variantItem.querySelector('.quantity-picker');
      const quantityInput = variantItem.querySelector('.quantity-input');

      addButton.parentElement.classList.remove('hidden');
      quantityPicker.classList.add('hidden');
      quantityInput.value = 1;
    });

    console.log('here', selectedSavors);

    updateSavorCounter();
  }

  async function showErrorWithDelay(message) {
    buyButton.setAttribute('aria-busy', 'true');
    await new Promise(resolve => setTimeout(resolve, 1000));
    buyButton.setAttribute('aria-busy', 'false');
    showError(message);
  }

  function showError(message) {
    if (errorMessageElement) {
      errorMessageElement.textContent = message;
      errorMessageContainer.classList.remove('fl-hidden');
      setTimeout(() => {
        errorMessageContainer.classList.add('fl-hidden');
      }, 5000); // Hide error after 5 seconds
    }
  }

  // Add new function to handle subscription options
  function updateSubscriptionOptions(selectedPack) {
    if (!subscriptionSelect) return;

    const subscriptionId = selectedPack?.dataset?.subscriptionId;
    const options = subscriptionSelect.querySelectorAll('option');

    // Enable all options (no longer disabling non-matching options)
    options.forEach(option => {
      option.disabled = false;
    });

    // If we're in pack mode (selectedPack exists) and subscription is active
    if (selectedPack && subscriptionId && isSubscriptionActive) {
      // Auto-select the matching subscription
      options.forEach(option => {
        const optionId = option.dataset.subscriptionPlanId;
        if (optionId === subscriptionId) {
          option.selected = true;
          currentSellingPlanId = subscriptionId;
          currentSubscriptionDiscount = parseFloat(option.dataset.subscriptionPlanDiscount) / 100;
        }
      });
    }
  }

  // New function to update pack selection based on subscription plan
  function updatePackFromSubscription(subscriptionPlanId) {
    if (!subscriptionPlanId || !packsConfigurator || !packItems.length) {
      return;
    }

    // Prevent infinite loop
    isUpdatingFromSubscription = true;

    // Find the pack that matches this subscription ID
    const matchingPack = Array.from(packItems).find(pack => {
      const packSubscriptionId = pack.dataset.subscriptionId;
      return packSubscriptionId && packSubscriptionId === subscriptionPlanId;
    });

    if (matchingPack && matchingPack !== selectedPack) {
      // Remove active class from all packs
      packItems.forEach(p => p.classList.remove('active'));

      // Add active class to matching pack
      matchingPack.classList.add('active');
      selectedPack = matchingPack;

      // Update UI elements
      if (freeDeliveryText) {
        const hasDelivery = matchingPack.dataset.freeDelivery === 'true';
        if (hasDelivery) {
          freeDeliveryText.classList.remove('fl-hidden');
        } else {
          freeDeliveryText.classList.add('fl-hidden');
        }
      }

      updateMaxSavors(matchingPack);
      updatePackPrices(matchingPack);

      // Handle single variant case when switching packs
      if (variantItems.length === 1) {
        const singleVariant = variantItems[0];
        const variantId = singleVariant.dataset.variantId;
        selectedSavors = {};
        selectedSavors[variantId] = parseInt(matchingPack.dataset.packQuantity);
        updateCartObject();
        updateSavorCounter();
      } else {
        const currentSavorCount = Object.values(selectedSavors).reduce((sum, qty) => sum + qty, 0);
        if (currentSavorCount > parseInt(matchingPack.dataset.packQuantity)) {
          resetSelections();
        }
      }
    }

    // Handle V2 packs - update flavor selector visibility
    const v2Packs = document.querySelectorAll('.fl-pack-v2');
    if (v2Packs.length > 0) {
      // Find matching V2 pack by subscription ID
      const matchingV2Pack = Array.from(v2Packs).find(pack => {
        const packSubscriptionId = pack.dataset.subscriptionId;
        return packSubscriptionId && packSubscriptionId === subscriptionPlanId;
      });

      if (matchingV2Pack) {
        // Remove active from all V2 packs
        v2Packs.forEach(p => p.classList.remove('active'));
        // Add active to matching pack
        matchingV2Pack.classList.add('active');

        // Show/hide flavor selectors based on active pack (V2 style)
        v2Packs.forEach(p => {
          const flavorSelector = p.querySelector('[data-flavor-selector]');
          if (flavorSelector) {
            if (p.classList.contains('active')) {
              flavorSelector.classList.remove('hidden');
            } else {
              flavorSelector.classList.add('hidden');
            }
          }

          // V4: Show/hide multiple selectors container
          const v4Selectors = p.querySelector('[data-v4-selectors]');
          if (v4Selectors) {
            if (p.classList.contains('active')) {
              v4Selectors.classList.remove('hidden');
            } else {
              v4Selectors.classList.add('hidden');
            }
          }
        });

        // Update cart with new pack's flavor selection
        if (typeof updateCartObjectV2 === 'function') {
          updateCartObjectV2();
        }

        // Update prices
        updatePackPrices(matchingV2Pack);
      }
    }

    // Reset flag after a short delay to allow other updates
    setTimeout(() => {
      isUpdatingFromSubscription = false;
    }, 100);
  }

  // Initialize subscription functionality
  initSubscription();

  // ========================================
  // FLAVOR SELECTOR V2 - Simple Dropdown
  // ========================================

  function initFlavorSelectorsV2() {
    const flavorSelectors = document.querySelectorAll('[data-flavor-selector]');

    flavorSelectors.forEach((selector) => {
      const trigger = selector.querySelector('[data-select-trigger]');
      const dropdown = selector.querySelector('[data-flavor-dropdown]');
      // Support both V2/V3 ([data-variant-select]) and V4 ([data-v4-flavor-select])
      const nativeSelect = selector.querySelector('[data-variant-select]') || selector.querySelector('[data-v4-flavor-select]');
      const options = selector.querySelectorAll('.fl-pack-v2__dropdown-option');
      const flavorDot = selector.querySelector('[data-flavor-dot]');
      const selectedText = selector.querySelector('[data-selected-text]');

      if (!trigger || !dropdown) return;

      // Toggle dropdown on trigger click
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        // Close all other dropdowns and reset z-index on their packs
        document.querySelectorAll('[data-flavor-selector]').forEach(s => {
          if (s !== selector) {
            s.classList.remove('open');
            const parentPack = s.closest('.fl-pack-v2');
            if (parentPack) parentPack.style.zIndex = '';
          }
        });

        // Toggle current dropdown
        selector.classList.toggle('open');

        // Raise z-index on parent pack when dropdown is open
        const parentPack = selector.closest('.fl-pack-v2');
        if (parentPack) {
          parentPack.style.zIndex = selector.classList.contains('open') ? '100' : '';
        }
      });

      // Handle option selection
      options.forEach((option) => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();

          if (option.classList.contains('disabled')) return;

          const variantId = option.dataset.variantId;
          const flavorName = option.dataset.flavorName;
          const flavorColor = option.dataset.flavorColor;
          const flavorImage = option.dataset.flavorImage;

          // Update native select
          if (nativeSelect) {
            nativeSelect.value = variantId;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Update trigger display
          if (flavorDot) {
            if (flavorImage) {
              flavorDot.style.backgroundImage = `url('${flavorImage}')`;
              flavorDot.style.backgroundColor = '';
            } else if (flavorColor) {
              flavorDot.style.backgroundImage = '';
              flavorDot.style.backgroundColor = flavorColor;
            }
          }
          if (selectedText) {
            // V4: prefix with index number (e.g., "1.Neutre")
            const flavorIndex = selector.dataset.flavorIndex;
            if (flavorIndex) {
              selectedText.textContent = `${flavorIndex}.${flavorName}`;
            } else {
              selectedText.textContent = flavorName;
            }
          }

          // Mark as selected
          options.forEach(opt => opt.classList.remove('selected'));
          option.classList.add('selected');

          // Close dropdown
          selector.classList.remove('open');

          // Update cart object with new selection (V2 mode)
          if (typeof updateCartObjectV2 === 'function') {
            updateCartObjectV2();
          }
        });
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-flavor-selector]')) {
        document.querySelectorAll('[data-flavor-selector]').forEach(s => {
          s.classList.remove('open');
          // Reset z-index on parent pack
          const parentPack = s.closest('.fl-pack-v2');
          if (parentPack) parentPack.style.zIndex = '';
        });
      }
    });
  }

  // Initialize V2 flavor selectors if present
  if (document.querySelector('[data-flavor-selector]')) {
    initFlavorSelectorsV2();

    // Initialize cart with default selection (first flavor of active pack)
    const hasVariantComposer = variantItems && variantItems.length > 0;
    if (!hasVariantComposer) {
      updateCartObjectV2();
    }
  }

  // Add pack click handler for V2 packs
  const v2Packs = document.querySelectorAll('.fl-pack-v2');
  if (v2Packs.length > 0) {
    v2Packs.forEach(pack => {
      pack.addEventListener('click', function (e) {
        // Don't trigger if clicking on the flavor selector
        if (e.target.closest('[data-flavor-selector]')) return;

        // Remove active from all packs
        v2Packs.forEach(p => p.classList.remove('active'));

        // Add active to clicked pack
        this.classList.add('active');

        // Update other pack-related state (reuse existing logic)
        const packQuantity = this.dataset.packQuantity;
        if (maxSavorsElement) {
          maxSavorsElement.textContent = packQuantity;
        }

        // Handle free delivery visibility
        if (freeDeliveryText) {
          const hasDelivery = this.dataset.freeDelivery === 'true';
          if (hasDelivery) {
            freeDeliveryText.classList.remove('fl-hidden');
          } else {
            freeDeliveryText.classList.add('fl-hidden');
          }
        }

        // Update cart with new pack's flavor selection (V2 mode)
        if (typeof updateCartObjectV2 === 'function') {
          updateCartObjectV2();
        }

        // Update prices
        updatePackPrices(this);

        // Show/hide flavor selectors based on active pack (V2 style)
        v2Packs.forEach(p => {
          const flavorSelector = p.querySelector('[data-flavor-selector]');
          if (flavorSelector) {
            if (p.classList.contains('active')) {
              flavorSelector.classList.remove('hidden');
            } else {
              flavorSelector.classList.add('hidden');
            }
          }

          // V4: Show/hide multiple selectors container
          const v4Selectors = p.querySelector('[data-v4-selectors]');
          if (v4Selectors) {
            if (p.classList.contains('active')) {
              v4Selectors.classList.remove('hidden');
            } else {
              v4Selectors.classList.add('hidden');
            }
          }
        });
      });
    });
  }

  // Initialize V4 flavor selectors (uses same dropdown logic as V2)
  // The initFlavorSelectorsV2() already handles [data-flavor-selector] which V4 uses
});